export function removeDuplicates(
  obj: Record<string, string>,
): Record<string, string> {
  const valueMap: Record<string, boolean> = {};
  const result: Record<string, string> = {};

  for (const key in obj) {
    const valueKey = String(obj[key]);
    if (!valueMap[valueKey]) {
      valueMap[valueKey] = true;
      result[key] = obj[key];
    }
  }

  return result;
}

export const sortByValues = (
  sortableObj: Record<string, string>,
): Record<string, string> => {
  return Object.entries(sortableObj)
    .sort(([, a], [, b]) => {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    })
    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
};
